import { CoachStep } from '../components/CoachMark'

/**
 * 홈 화면 코치마크 튜토리얼.
 * 대상 요소는 각 컴포넌트에 data-tutorial="<selector>" 로 표시돼 있어야 한다.
 * 문구는 자유롭게 수정 가능(디자인/카피 튜닝).
 */
export const HOME_TUTORIAL_STEPS: CoachStep[] = [
  {
    selector: 'logo',
    description:
      '네이버·카카오 지도에 저장해둔 리스트를 붙여넣으면 다녀온 곳을 한 번에 기록할 수 있어요.',
  },
  {
    // 왼쪽에서 두번째 아이콘(nav-feed) → 내가 기록한 장소 랭킹
    selector: 'nav-feed',
    description: '내가 기록한 장소들의 랭킹을 확인할 수 있어요.',
    pad: 8,
    radius: 14,
  },
  {
    // 마이 탭 아이콘. '다음' 누르면 다음 스텝(플레이트리스트)이 마이 탭으로 데려감.
    selector: 'nav-my',
    description: '내 기록·플레이트리스트들을 확인 할 수 있어요.',
    pad: 8,
    radius: 14,
    buttonLabel: '다음',
  },
  {
    // 마이 탭의 플레이트리스트 추가(+) 버튼. 이 스텝 진입 시 마이 탭으로 이동.
    selector: 'platelist-add',
    description: '가고 싶은 장소들을 친구와 함께 저장하세요',
    navigateTo: '/main-my',
    pad: 8,
    radius: 14,
    // 마지막 스텝이지만 버튼 문구는 '다음'으로 통일
    buttonLabel: '다음',
  },
]

/** 튜토리얼을 이미 봤는지 저장하는 localStorage 키 (문구/스텝 크게 바뀌면 버전 올림) */
export const HOME_TUTORIAL_SEEN_KEY = 'tastee_home_tutorial_seen_v1'

export const hasSeenHomeTutorial = (): boolean => {
  try {
    return localStorage.getItem(HOME_TUTORIAL_SEEN_KEY) === '1'
  } catch {
    return false
  }
}

export const markHomeTutorialSeen = (): void => {
  try {
    localStorage.setItem(HOME_TUTORIAL_SEEN_KEY, '1')
  } catch {
    /* noop */
  }
}
